import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { scheduledReportFrequencyTranslationMap } from 'dashboard/constants/scheduled-report-frequency-translation-map.constant';
import { BaseDataGridCellRenderer } from 'shared/abstract/base-data-grid-cell-renderer';

@Component({
    selector: 'app-scheduled-reports-frequency-cell-renderer',
    templateUrl: './scheduled-reports-frequency-cell-renderer.component.html',
    styleUrls: ['./scheduled-reports-frequency-cell-renderer.component.scss'],
    imports: [TranslateModule],
})
export class ScheduledReportsFrequencyCellRendererComponent extends BaseDataGridCellRenderer {
    public readonly frequencyTranslationMap: any = scheduledReportFrequencyTranslationMap;

    public onDataChange(): any {}
}
